import { Alert, Button, Form } from "react-bootstrap";
import FormRow from "./uiElements/FromRow.component";
import { useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import tradeService from "../services/trade.service";
import toast from "react-hot-toast";

import { ReactComponent as TrashIcon } from "../ui/Icons/trash.svg";

function AddTrade({ alert, tradeToEdit, onCloseModal }) {
  const queryClient = useQueryClient();
  const isEditSession = Boolean(tradeToEdit);

  const { register, formState, handleSubmit, reset } = useForm({
    defaultValues: isEditSession
      ? { ...tradeToEdit, tradeDate: tradeToEdit.tradeDate.split("T")[0] }
      : {
          ticker: alert?.ticker,
        },
  });
  const { errors } = formState;

  const { isPending: isCreating, mutate: createTrade } = useMutation({
    mutationFn: (data) => {
      tradeService.addTrade(data);
    },
    onSuccess: () => {
      toast.success("Trade Created successfully");
      queryClient.invalidateQueries({ queryKey: ["trades"] });
      reset();
    },
    onError: (err) => {
      toast.error("Something went wrong");
    },
  });

  const { isPending: isEditing, mutate: editTrade } = useMutation({
    mutationFn: (data) => tradeService.updateTrade(data),
    onSuccess: () => {
      toast.success("Trade Edited successfully");
      queryClient.invalidateQueries({ queryKey: ["trades"] });
      onCloseModal();
    },
    onError: (err) => {
      toast.error("Something went wrong");
    },
  });

  const isLoading = isCreating || isEditing;

  const submitHandler = (data) => {
    console.log(data);
    if (alert) {
      createTrade({ ...data, ticker: alert.ticker });
    } else if (isEditSession) {
      editTrade({ ...data });
    } else {
      createTrade(data);
    }
  };

  return (
    <form className="add-trade-form" onSubmit={handleSubmit(submitHandler)}>
      {isEditSession ? (
        <>
          <div className="mb-3 d-flex justify-content-between">
            <h4 className="mb-0">EDIT YOUR TRADE DATA</h4>
            <Button variant="outline-danger">
              <TrashIcon className="text-light" />
            </Button>
          </div>
          <Alert variant="warning">
            {" "}
            Edit trades dosen't reflect on profit/loss, scale out and scale in trades, you can reset trade before
            editing
          </Alert>
        </>
      ) : (
        <h3 className="m-auto mb-3">ADD YOUR TRADE DATA</h3>
      )}
      <hr />

      <div className="forms-container">
        <div className="form1">
          <FormRow label="Ticker" error={errors?.ticker?.message}>
            <Form.Control
              disabled={alert?.ticker}
              value={alert?.ticker}
              type="text"
              id="ticker"
              placeholder="Ticker"
              {...register("ticker", {
                required: "This field is required",
              })}
            />
          </FormRow>
          <FormRow label="Trade Date" error={errors?.tradeDate?.message}>
            <Form.Control
              type="date"
              id="tradeDate"
              {...register("tradeDate", {
                required: "This field is required",
                valueAsDate: true,
              })}
            />
          </FormRow>
          <FormRow label="Entry price" error={errors?.entryPrice?.message}>
            <Form.Control
              step="any"
              type="number"
              id="entryPrice"
              placeholder=" entry price"
              {...register("entryPrice", {
                required: "This field is required",
                valueAsNumber: true,
                min: {
                  value: 0.1,
                  message: "Entry price must be at least 0.1",
                },
              })}
            />
          </FormRow>
          <FormRow label="Quantity" error={errors?.quantity?.message}>
            <Form.Control
              type="number"
              id="quantity"
              placeholder=" Quantity"
              {...register("quantity", {
                required: "This field is required",
                valueAsNumber: true,
                min: {
                  value: 1,
                  message: "Quantity must be at least 1",
                },
              })}
            />
          </FormRow>
        </div>
        <div className="form2">
          <FormRow label="Take Profit" optional={true} error={errors?.takeProfit?.message}>
            <Form.Control
              type="number"
              id="takeProfit"
              placeholder=" Take Profit"
              {...register("takeProfit", {
                valueAsNumber: true,
                min: {
                  value: 1,
                  message: "Take Profit must be at least 1",
                },
              })}
            />
          </FormRow>

          <FormRow label="Stop Loss" optional={true} error={errors?.stopLoss?.message}>
            <Form.Control
              type="number"
              id="stopLoss"
              placeholder=" Stop Loss"
              {...register("stopLoss", {
                valueAsNumber: true,
                min: {
                  value: 1,
                  message: "stopLoss must be at least 1",
                },
              })}
            />
          </FormRow>
          <FormRow label="Trade Direction" error={errors?.tradeDirection?.message}>
            <Form.Select
              id="tradeType"
              aria-label="Default select example"
              {...register("tradeType", {
                required: "This field is required",
              })}
            >
              <option value="">Choose trade type</option>
              <option value="short">Short</option>
              <option value="long">Long</option>
            </Form.Select>
          </FormRow>
          <FormRow label="Trade Rationale">
            <Form.Control
              type="text"
              id="tradeRationale"
              placeholder=" Trade Rationale"
              {...register("tradeRationale")}
            />
          </FormRow>
        </div>
      </div>
      <div className="w-100 trade-btn">
        <Button onClick={onCloseModal} className="trade-btn" variant="outline-secondary">
          CANCEL
        </Button>
        <Button type="submit" className="trade-btn" variant="success" disabled={isLoading}>
          {isEditSession ? "EDIT TRADE" : "ADD TRADE"}
        </Button>
      </div>
    </form>
  );
}

export default AddTrade;
